export interface OrganizationAddressSuggestion {
    id: string;
    label: string;
    address_1: string;
    city: string;
    state: string;
    zip_code: string;
}

export enum CspTier {
    SCOUT = "scout",
    GUARDIAN = "guardian",
    SENTINEL_ELITE = "sentinel_elite",
}

export interface Organization {
    id: number;
    name: string;
    management_information: null;
    group_type: string;
    csp_tier: CspTier | null;
    service_provider: Serviceprovider;
    servicing_farms: number[];
    additional_advisors: Additionaladvisor[];
    group_admins: number[];
    crm_id: null;
    hubspot_link: null;
    account_manager: number;
    address_1: string | null;
    address_2: string | null;
    city: string | null;
    state: string | null;
    zip_code: string | null;
    primary_contact: null;
    invoice_date: null;
}

export interface OrganizationAvailableCredits {
    organization_id: number;
    available_credits: number | string;
}

interface Additionaladvisor {
    id: number;
    username: string;
    full_name: string;
    is_staff: boolean;
    is_active: boolean;
    account_type: string;
    organization: string;
    is_group_admin: boolean;
    hubspot_link: string;
}

interface Serviceprovider {
    id: number;
    name: string;
    group_type: string;
}
